export function membershipsRevenue(state = [], action) {
  switch (action.type) {
    case "MEMBERSHIP_REVENUE_ANALYTICS_SUCCESS":
      return action.data;
    default:
      return state;
  }
}
